<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>判读信息</el-breadcrumb-item>
      <el-breadcrumb-item>检查阶段</el-breadcrumb-item>
      <el-breadcrumb-item>查看</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <section class="main-body">
      <ClientBasicInfo :teleNum="teleNum" :print="false" /> <br />
      <el-button v-if="false" size="mini" type="primary" @click="dialogVisible = true"
        >打印预览</el-button
      >
      <!-- <el-button size="mini" type="primary" > -->
      <!-- 知情同意书下载 -->
      <a v-if="false"
        style="margin-left: 30px; font-size: 14px"
        target="_blank"
        href="https://hyperq.xyz:8443/web/api/ExamService/download/96c81d618bfe4cef8dae95d60f16b6ea/pdf"
        >知情同意书下载</a
      >
      <!-- </el-button> -->
      <el-collapse border>
        <el-collapse-item v-if = false title="病人自述" name="1">
          <SelfStatement :teleNum="teleNum" :disabled="false" />
        </el-collapse-item>
        <el-collapse-item title="基础问询" name="2">
          <BasicQuery :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item v-if = false title="基础检查" name="3">
          <BasicCheck :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="中医经络检测" name="4">
          <Emc :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="检测数据上传" name="5">
          <Ecg :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item v-if = false title="HyperQ Stress" name="6">
          <HyperQ :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item v-if = false title="HyperQ Rest" name="7">
          <HyperQRest :examUuid="examUuid" />
        </el-collapse-item>
        <el-collapse-item title="检测结果及健康建议" name="8">
          <el-button v-if=false size="mini" type="primary" @click="dialogVisible_2 = true"
            >处方打印预览</el-button
          >
          <Prescription :examUuid="examUuid" />
        </el-collapse-item>
      </el-collapse>
      <el-row :gutter="30">
        <el-col :span="24" class="alignCenter">
          <el-button
            type="primary"
            size="medium"
            @click="goBack"
            class="fullWidth"
            >返回</el-button
          >
        </el-col>
      </el-row>
    </section>

    <!--检测前文件 打印预览对话框-->
    <el-dialog
      title="毕胜普生物科技有限公司"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="100%"
      :before-close="handleClose"
    >
      <div ref="print">
        <h1 style="text-align: center">HyperQ 测 试 信 息 表</h1>
        <hr />
        <div class="print_panel">
          <el-button
            size="mini"
            type="primary"
            @click="print"
            v-show="printBtnVisible"
            >打印检测报告</el-button
          >
          <ClientBasicInfo
            :teleNum="teleNum"
            :print="true"
            style="margin-right: 20px"
          />
          <hr />
          <BasicQueryPrint :examUuid="examUuid" />
          <hr />
          <AbsoluteContradictionsPrint />
        </div>
        <h3 class="signiture">患者签名：</h3>
        <h3 class="signiture">医生签名：</h3>
        <h3 class="signiture">日期：</h3>
        <!-- <span slot="footer" class="dialog-footer" style="text-align:right">
          <b style='right:100px'>医生签名</b>
          <b>日期</b>
        </span> -->
      </div>
    </el-dialog>

    <!--检测后处方 打印预览对话框-->
    <el-dialog
      title="毕胜普生物科技有限公司"
      :visible.sync="dialogVisible_2"
      width="100%"
      :before-close="handleClose_2"
      v-if="dialogVisible_2"
    >
      <div ref="print_2">
        <h1 style="text-align: center">HyperQ 处方</h1>
        <hr />
        <div class="print_panel">
          <el-button
            size="mini"
            type="primary"
            @click="print_2"
            v-show="printBtnVisible_2"
            >打印检测报告</el-button
          >
          <PrescriptionPrint :examUuid="examUuid" :disabled="true" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//引入用户基本信息组件
// import ClientBasicInfo from "../../../components/common/ClientBasicInfo"
import ClientBasicInfo from "../../../components/common/ClientBasicInfo";
//引入病人自述 - 绝对禁忌症 与 既往病史
import SelfStatement from "../../../components/common/selfStatement";
//引入绝对禁忌症文件
// import AbsoluteContradictions from "../../../components/common/AbsoluteContradictions"
import AbsoluteContradictionsPrint from "../../../components/common/AbsoluteContradictionsPrint";
//引入BasicQuery - 基础问询 组件
import BasicQuery from "../../../components/common/BasicQueryNew";
import BasicQueryPrint from "../../../components/common/BasicQueryPrint";
//引入BasicCheck - 基础检查 组件
import BasicCheck from "../../../components/common/BasicCheck";
//引入Emc检查组件
// import Emc from "../../../components/common/Emc"
import Emc from "../../../components/common/CCT";
//引入Ecg心电图组件
import Ecg from "../../../components/common/Ecg";
//引入HyperQ组件
import HyperQ from "../../../components/common/HyperQ";
import HyperQRest from "../../../components/common/HyperQRest";
//引入Prescription组件
import Prescription from "../../../components/common/Prescription";
import PrescriptionPrint from "../../../components/common/PrescriptionPrint";

export default {
  name: "clientInfo",
  components: {
    ClientBasicInfo,
    BasicQuery,
    BasicQueryPrint,
    BasicCheck,
    Emc,
    Ecg,
    HyperQ,
    SelfStatement,
    Prescription,
    PrescriptionPrint,
    // AbsoluteContradictions,
    AbsoluteContradictionsPrint,
    HyperQRest
  },
  data() {
    return {
      disabled: true,
      examUuid: "",
      teleNum: "",
      dialogVisible: false,
      printBtnVisible: true,
      dialogVisible_2: false,
      printBtnVisible_2: true,
    };
  },
  methods: {
    downloadConcentForm() {
      window.location.href(
        "https://hyperq.xyz:8443/web/api/ExamService/download/96c81d618bfe4cef8dae95d60f16b6ea/pdf"
      );
    },
    handleClose() {
      this.dialogVisible = false;
      this.printBtnVisible = true;
    },
    handleClose_2() {
      this.dialogVisible_2 = false;
      this.printBtnVisible_2 = true;
    },
    //后退一步
    goBack() {
      this.$router.push({ path: "/doctor/check" });
    },
    print() {
      this.printBtnVisible = false;
      setTimeout(() => {
        this.$print(this.$refs.print);
      }, 1000);
    },
    print_2() {
      this.printBtnVisible_2 = false;
      setTimeout(() => {
        this.$print(this.$refs.print_2);
      }, 1000);
    },
  },
  created() {
    this.examUuid = this.$route.query.examUuid;
    this.teleNum = this.$route.query.teleNum;
  },
};
</script>
<style scoped lang=less>
header {
  margin-top: 30px;
}
.main-body {
  width: 80%;
  margin: 0 auto;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

/* .pad {
  padding-left: 40px;
} */

.checkFeedbackInfo {
  margin-bottom: 10px;
}

.leftpad {
  padding-left: 30px;
}

.alignCenter {
  text-align: center;
}
/*
.shortInput {
  width: 40px;
}

.mediumInput {
  width: 80px;
}

.longInput {
  width: 200px;
} */
.fullWidth {
  width: 100%;
}

/* 防止只打印一页 */
@media print {
  body {
    height: auto;
  }
}
.print_panel {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 100px;
}
.signiture {
  margin-left: 65%;
}
</style>